import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '../store/index';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
  },
  {
    path: '/menu',
    name: 'Menu',
    component: () => import('../components/AppMenu.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    beforeEnter(to, from, next) {
      if (from.name === null) next('/');
      else next();
    },
  },
  {
    path: '*',
    redirect: '/',
  },
];

store.state.pages.forEach(({ path, name }) => {
  const route = {
    path: `/${path}`,
    name,
    component: () => import('../views/Info.vue'),
    beforeEnter(to, from, next) {
      if (from.name === null) store.commit('goAtPage', to.name);
      next();
    },
  };
  routes.push(route);
});

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
